// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { TextFieldProps } from "@west/MobiusOverrides/TextField/TextField";
import { editCardModalStyles } from "@west/Overrides/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

editCardModalStyles.address1TextField = {
    ...editCardModalStyles.address1TextField,
    type: "address",
} as TextFieldProps;

editCardModalStyles.address2TextField = {
    ...editCardModalStyles.address2TextField,
    type: "address",
} as TextFieldProps;

editCardModalStyles.address3TextField = {
    ...editCardModalStyles.address3TextField,
    type: "address",
} as TextFieldProps;

editCardModalStyles.address4TextField = {
    ...editCardModalStyles.address4TextField,
    type: "address",
} as TextFieldProps;

editCardModalStyles.cityTextField = {
    ...editCardModalStyles.cityTextField,
    type: "city",
} as TextFieldProps;

editCardModalStyles.postalCodeTextField = {
    ...editCardModalStyles.postalCodeTextField,
    type: "postalCode",
} as TextFieldProps;

editCardModalStyles.editCardModal = {
    sizeVariant: "large",
};

editCardModalStyles.notifyError = {
    css: css`
        margin-bottom: 0;
        align-self: flex-start;
        ${xScreen("lte", "sm")} {
            margin-bottom: 10px;
        }
    `,
};
editCardModalStyles.notifyErrorWrapper = {
    css: css`
        padding: 10px;
        &:empty {
            display: none;
        }
    `,
};

editCardModalStyles.bottomGridItem = {
    width: 12,
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

editCardModalStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                css`
                    margin-right: 20px;
                `,
                css`
                    margin-right: 20px;
                `,
                css`
                    margin-right: 20px;
                `,
            ])}
    `,
};

editCardModalStyles.expirationMonthGridItem = {
    width: [7, 7, 8, 8, 8],
};

editCardModalStyles.expirationYearGridItem = {
    width: [5, 5, 4, 4, 4],
    css: css`
        align-items: flex-end;
    `,
};
